import { useMemo } from 'react'

import {
  Stack,
  StackProps
} from '@mui/material'
import Grid from '@mui/material/Grid'

import { BlockCaption } from 'components/controls/blockCaption'

import { useGetManufacturerLogo } from 'interface/manufacturer'

import { SearchRecord } from './searchRecord'
import { SearchListWithManufacturer } from 'features/search/types'

type ManufacturerBlockProps = {
  manufacturer: SearchListWithManufacturer
  onSelectSearch: (searchId: number) => void
} & StackProps
export const ManufacturerBlock = ({
  manufacturer,
  onSelectSearch,
  ...others
}: ManufacturerBlockProps) => {
  const manufacturerLogoState = useGetManufacturerLogo(manufacturer.manufacturerId, manufacturer.updateTime)
  const logo = useMemo(
    () => {
      return manufacturerLogoState.data ? URL.createObjectURL(manufacturerLogoState.data.blob) : undefined
    },
    [manufacturerLogoState.data]
  )
  return (
    <Stack direction="column" {...others} padding={2}>
      <BlockCaption caption={manufacturer.manufacturerName} variant="body1" />
      <Grid container paddingTop={2} spacing={2}>
        {manufacturer.searchList.map((search) => (
          <Grid
            key={`search-${search.searchId}`}
            size={{ xs: 12, sm: 12, md: 6, lg: 4, xl: 3 }}
          >
            <SearchRecord
              logo={logo}
              record={search}
              onSelectSearch={onSelectSearch}
            />
          </Grid>
        ))}
      </Grid>
    </Stack>
  )
}